import { createFileRoute } from "@tanstack/react-router";
import { AssistentePreviewPage } from "@/paginas/pg_assistente/assistente-preview";

export const Route = createFileRoute("/_authenticated/assistente-preview")({
  component: AssistentePreviewPage,
});
